import { g as o } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as s, normalizeClass as d, createElementVNode as t } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconGoogleDocs",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (l) => Object.keys(i).includes(l)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = o();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], p = ["fill"], v = ["id"];
function h(l, a, n, g, A, e) {
  return r(), s("svg", {
    "aria-label": n.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--google-docs"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Google Docs",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a[1] || (a[1] = t("path", {
      d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v19A1.5 1.5 0 0 0 5.5 23h13a1.5 1.5 0 0 0 1.5-1.5V7l-6-6H5.5Z",
      fill: "#4E8DF5"
    }, null, -1)),
    a[2] || (a[2] = t("path", {
      d: "M5.5 23A1.5 1.5 0 0 1 4 21.5v-.25a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v.25a1.5 1.5 0 0 1-1.5 1.5h-13Z",
      fill: "#417EE9"
    }, null, -1)),
    a[3] || (a[3] = t("path", {
      d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v.25a1.5 1.5 0 0 1 1.5-1.5h8.75L14 1H5.5Z",
      fill: "#639AF6"
    }, null, -1)),
    t("path", {
      d: "M20 12.125V7l-.875-.875h-4.22a.375.375 0 0 0-.265.64l5.36 5.36Z",
      fill: `url(#${l.uniqueID}a)`
    }, null, 8, p),
    a[4] || (a[4] = t("path", {
      d: "m14 1 6 6h-4.5A1.5 1.5 0 0 1 14 5.5V1Z",
      fill: "#A6C5FA"
    }, null, -1)),
    a[5] || (a[5] = t("path", {
      d: "M16 12H8v1h8v-1Zm0 2H8v1h8v-1Zm-8 2h8v1H8v-1Zm6 2H8v1h6v-1Z",
      fill: "#fff"
    }, null, -1)),
    t("defs", null, [
      t("linearGradient", {
        id: `${l.uniqueID}a`,
        x1: "17",
        y1: "12.125",
        x2: "17",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      }, [...a[0] || (a[0] = [
        t("stop", { "stop-color": "#4E8DF5" }, null, -1),
        t("stop", {
          offset: "1",
          "stop-color": "#3D6ACD"
        }, null, -1)
      ])], 8, v)
    ])
  ], 10, m);
}
const H = /* @__PURE__ */ u(f, [["render", h]]);
export {
  H as default
};
//# sourceMappingURL=google-docs.js.map
